export default "__VITE_ASSET__Dt6nw5tD__"